<template>
    <div :class="'sitebuilder-element-panel'  + hideControl()" :data-fixed="fixedBanner()"
         :data-fixed-mobile="fixedBannerMobile()" :data-tag="dataTag()">
        <div v-bind:style="{
        'border-radius': radius,
        background: backgroundColor,
        backgroundImage: backgroundImage,
        backgroundSize: backgroundSize,
        backgroundPosition: backgroundPosition,
        backgroundOrigin: backgroundOrigin,
        backgroundRepeat: backgroundRepeat,
        height : height,
        minHeight : minHeight,
        border : border,
        'box-shadow': boxShadow,
      }"
             :id="this.internal_config.id"
             ref="elem"
             element="PanelComponent"
             :data-hide-desktop="!this.internal_config.showDesktop"
             :data-hide-mobile="!this.internal_config.showMobile"
             class="panel panel-primary draggable container-fluid ">
            <div class="panel-video-place"
                 v-show="internal_config.video != '' && internal_config.videoInternal == false">
                <video class="panel-video" :autoplay="internal_config.autoplay" :muted="internal_config.muted"
                       :loop="internal_config.loop" id="myVideo">
                    <source :src="srcVideo" :type="typeVideo">
                </video>
            </div>
            <div class="panel-body container" v-bind:style="{
             background: internalBackgroundColor,
            backgroundImage: internalBackgroundImage,
            backgroundSize: internalBackgroundSize,
            backgroundPosition: internalBackgroundPosition,
            backgroundOrigin: internalBackgroundOrigin,
            backgroundRepeat: internalBackgroundRepeat,
            minHeight : minHeight,
            }">
                <div class="panel-video-place"
                     v-show="internal_config.video != '' && internal_config.videoInternal == true">
                    <video class="panel-video" :autoplay="internal_config.autoplay" :muted="internal_config.muted"
                           :loop="internal_config.loop" id="myVideoInternal">
                        <source :src="srcVideo" :type="typeVideo">
                    </video>
                </div>
                <component v-for="(element,index) in elements" :is="element.name" :config="element.config"
                           :childs="element.childs" :key="index"
                           :device="device"
                           :is_popup="is_popup"
                           :id="element.id" :height_start="index" :preview="preview"></component>
            </div>
            <div class="arrow-panel-down" v-show="internal_config.arrowActive"
                 v-bind:style="{width: widthArrow,left: leftArrow,'border-left': transparentArrowSide,'border-right': transparentArrowSide,'border-top': colorArrowSide}">
            </div>
        </div>
        <separator-panel ref="separatorData"></separator-panel>
        <div v-html="this.internal_config.separatorHtml"></div>
    </div>
</template>
<script>


	import Model from './Model';
	import ImageComponent from "../Image/Image.vue";
	import TextComponent from "../Text/Text.vue";
	import BoxComponent from "../Box/Box.vue";
	import ButtonComponent from "../Button/Button.vue";
	import MailingBossFormComponent from "../Forms/MailingBossForm/MailingBossForm";
	import GetResponseFormComponent from "../Forms/GetResponseForm/GetResponseForm";
	import SimpleFormComponent from "../Forms/SimpleForm/SimpleForm";
	import VimeoVideoComponent from "../Vimeo/Vimeo";
	import WebinarVideoComponent from "../Webinar/Webinar";
	import WistiaVideoComponent from '../Wistia/Wistia';
	import YoutubeVideoComponent from "../YoutubeVideo/Youtube";
	import IframeComponent from "../Iframe/Iframe";
	import TimerComponent from "../Timer/Timer";
	import SocialBarComponent from "../SocialBar/SocialBar"
	import MenuComponent from "../Menu/Menu";
	import LineVComponent from "../LineV/LineV";
	import LineComponent from "../Line/Line";
	import SliderGalleryComponent from "../SliderGallery/SliderGallery"
	import ButtonUserComponent from "../ButtonUser/ButtonUser"
	import Image3DComponent from "../Image3D/Image3D";
	import CounterBarComponent from "../CounterBar/CounterBar";
	import CounterTextComponent from "../CounterText/CounterText";
	import SeparatorPanel from "./Separator";
	import ImageGalleryComponent from "../ImageGallery/ImageGallery"

	export default {
		name: 'PanelElement',
		components: {
			ImageGalleryComponent,
			SeparatorPanel,
			CounterTextComponent,
			CounterBarComponent,
			Image3DComponent,
			SliderGalleryComponent,
			LineComponent,
			LineVComponent,
			MenuComponent,
			ButtonComponent,
			ImageComponent,
			IframeComponent,
			TextComponent,
			YoutubeVideoComponent,
			SocialBarComponent,
			BoxComponent,
			MailingBossFormComponent,
			GetResponseFormComponent,
			SimpleFormComponent,
			TimerComponent,
			VimeoVideoComponent,
			WistiaVideoComponent,
			WebinarVideoComponent,
			ButtonUserComponent
		},
		props: ['config', 'childs', 'height_start', 'device', 'id', 'preview', 'is_popup'],
		data() {
			return Model.data()
		},
		computed: {
			widthArrow() {
				if (this.device == 'desktop') {
					return this.internal_config.arrowWidth + '%';
				} else {
					return this.internal_config.arrowWidthMobile + '%';
				}
			},
			leftArrow() {

				if (this.device == 'desktop') {
					let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidth / 2);
					return 'calc(50% - ' + arrowWidth + 'px)';
				} else {
					let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidthMobile / 2);
					return 'calc(50% - ' + arrowWidth + 'px)';
				}

			},
			transparentArrowSide() {

				if (this.device == 'desktop') {
					let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidth / 2);
					return arrowWidth + 'px solid transparent';
				} else {
					let arrowWidth = parseInt($('.sitebuilder-element-panel').width()) / 100 * (this.internal_config.arrowWidthMobile / 2);
					return arrowWidth + 'px solid transparent';
				}

			},
			colorArrowSide() {
				return this.internal_config.arrowHeight + 'px solid ' + this.internal_config.arrowColor;
			},

			minHeight() {
				return this.internal_config.minHeight;
			},
			border() {
				if (typeof this.internal_config.border !== 'undefined') {
					let splitedBorder = this.internal_config.border.split(' ');

					if (typeof splitedBorder[2] !== 'undefined' && this.$globalStoreHelpers.isValidHex(splitedBorder[2])) {
						splitedBorder[2] = this.$globalStoreHelpers.hexToRGBA(splitedBorder[2]);
						this.internal_config.border = splitedBorder.join(' ');
					}
				}
				return this.internal_config.border;
			},
			height() {
				return this.internal_config.height;
			},
			boxShadow() {
				return this.internal_config.boxShadow;
			},
			radius() {
				return this.internal_config.borderRadius;
			},
			backgroundColor() {

				if (this.$globalStoreHelpers.isValidHex(this.internal_config.backgroundColor)) {
					this.internal_config.backgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.backgroundColor);
				}

				return this.internal_config.backgroundColor;
			},
			backgroundImage() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					this.internal_config.backgroundImage = this.internal_config.backgroundImage.replace('omb11.com', 'storage.builderall.com');
					return 'url("' + this.internal_config.backgroundImage + '")';
				}
				return '';
			},
			backgroundPosition() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundPosition
				}
				return '';
			},
			backgroundOrigin() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundOrigin
				}
				return '';
			},
			backgroundRepeat() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundRepeat
				}
				return '';
			},
			backgroundSize() {
				if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
					return this.internal_config.backgroundSize
				}
				return '';
			},
			internalBackgroundColor() {

				if (this.$globalStoreHelpers.isValidHex(this.internal_config.internalBackgroundColor)) {
					this.internal_config.internalBackgroundColor = this.$globalStoreHelpers.hexToRGBA(this.internal_config.internalBackgroundColor);
				}


				return this.internal_config.internalBackgroundColor;
			},
			internalBackgroundImage() {
				if (this.internal_config.internalBackgroundImage !== 'none' && typeof this.internal_config.internalBackgroundImage !== 'undefined') {
					this.internal_config.internalBackgroundImage = this.internal_config.internalBackgroundImage.replace('omb11.com', 'storage.builderall.com');
					return 'url("' + this.internal_config.internalBackgroundImage + '")';
				}
				return '';
			},
			internalBackgroundPosition() {
				if (this.internal_config.internalBackgroundImage !== 'none' && typeof this.internal_config.internalBackgroundImage !== 'undefined') {
					return this.internal_config.internalBackgroundPosition
				}
				return '';
			},
			internalBackgroundOrigin() {
				if (this.internal_config.internalBackgroundImage !== 'none' && typeof this.internal_config.internalBackgroundImage !== 'undefined') {
					return this.internal_config.internalBackgroundOrigin
				}
				return '';
			},
			internalBackgroundRepeat() {
				if (this.internal_config.internalBackgroundImage !== 'none' && typeof this.internal_config.internalBackgroundImage !== 'undefined') {
					return this.internal_config.internalBackgroundRepeat
				}
				return '';
			},
			internalBackgroundSize() {
				if (this.internal_config.internalBackgroundImage !== 'none' && typeof this.internal_config.internalBackgroundImage !== 'undefined') {
					return this.internal_config.internalBackgroundSize
				}
				return '';
			},
			typeVideo() {
				try {
					if (typeof this.internal_config.video != 'undefined' && this.internal_config.video != '') {
						return 'video/' + this.internal_config.video.split('.').pop();
					}
				} catch (e) {
					console.log(e);
					return '';
                }

				return '';
			},
			srcVideo() {
				try {
					if (typeof this.internal_config.video != 'undefined' && this.internal_config.video != '') {
						return this.internal_config.video;
					}
				} catch (e) {
					console.log(e);
					return '';
				}

				return '';
			},
		},
		methods: {

			panelDividerEffect() {
				this.internal_config.separatorHtml = '';
				if (this.internal_config.separatorActive) {
					let separatorColors = this.internal_config.separatorColors;


					if (this.$globalStoreHelpers.isValidHex(separatorColors['first'])) {
						separatorColors['first'] = this.$globalStoreHelpers.hexToRGBA(separatorColors['first']);
					}
					if (this.$globalStoreHelpers.isValidHex(separatorColors['second'])) {
						separatorColors['second'] = this.$globalStoreHelpers.hexToRGBA(separatorColors['second']);
					}
					if (this.$globalStoreHelpers.isValidHex(separatorColors['third'])) {
						separatorColors['third'] = this.$globalStoreHelpers.hexToRGBA(separatorColors['third']);
					}
					if (this.$globalStoreHelpers.isValidHex(separatorColors['fourth'])) {
						separatorColors['fourth'] = this.$globalStoreHelpers.hexToRGBA(separatorColors['fourth']);
					}

					if (this.internal_config.separatorEffect == 'waves-floating')
						this.internal_config.separatorHtml = this.$refs.separatorData.wavesSeparator(separatorColors['first'], separatorColors['second'], separatorColors['third'], separatorColors['fourth']);
					if (this.internal_config.separatorEffect == 'drip-up')
						this.internal_config.separatorHtml = this.$refs.separatorData.dripColors(separatorColors['first'], separatorColors['second'], separatorColors['third'], 'up');
					if (this.internal_config.separatorEffect == 'drip-down')
						this.internal_config.separatorHtml = this.$refs.separatorData.dripColors(separatorColors['first'], separatorColors['second'], separatorColors['third'], 'down');
					if (this.internal_config.separatorEffect == 'mid-arrow')
						this.internal_config.separatorHtml = this.$refs.separatorData.midArrow(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'waves-fixed')
						this.internal_config.separatorHtml = this.$refs.separatorData.wavesFixed(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'polygon')
						this.internal_config.separatorHtml = this.$refs.separatorData.polygonCraqued(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'polygon-up')
						this.internal_config.separatorHtml = this.$refs.separatorData.polygonUp(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'banner-lateral')
						this.internal_config.separatorHtml = this.$refs.separatorData.bannerLateral(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'drops')
						this.internal_config.separatorHtml = this.$refs.separatorData.drops(separatorColors['first'], separatorColors['second']);
					if (this.internal_config.separatorEffect == 'waves-lateral')
						this.internal_config.separatorHtml = this.$refs.separatorData.wavesLateral(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'zigzag')
						this.internal_config.separatorHtml = this.$refs.separatorData.zigzag(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'big-arrow')
						this.internal_config.separatorHtml = this.$refs.separatorData.bigArrow(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'clouds')
						this.internal_config.separatorHtml = this.$refs.separatorData.cloudsEffect(separatorColors['first']);
					if (this.internal_config.separatorEffect == 'curve')
						this.internal_config.separatorHtml = this.$refs.separatorData.curveEffect(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'arrow-reverse')
						this.internal_config.separatorHtml = this.$refs.separatorData.arrowReverse(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'pixels')
						this.internal_config.separatorHtml = this.$refs.separatorData.pixels(separatorColors['first'], separatorColors['second'], separatorColors['third']);
					if (this.internal_config.separatorEffect == 'big-round')
						this.internal_config.separatorHtml = this.$refs.separatorData.bigRound(separatorColors['first'], separatorColors['second']);
					if (this.internal_config.separatorEffect == 'breaker')
						this.internal_config.separatorHtml = this.$refs.separatorData.breaker(separatorColors['first'], separatorColors['second'], separatorColors['third']);
				}
			},

			dataTag() {
				if (this.internal_config.tag) {
					return this.internal_config.tag;
				}
				return '';
			},
			fixedBanner() {

				if (this.internal_config.fixed) {
					let firstEl = document.querySelector("#editor-content > .sitebuilder-element-panel");

					if (this.$el == firstEl)
						this.$root.$emit('setFixedStartPanel', this.internal_config.height)

					return this.$el == firstEl;
				}

				return false;
			},
			fixedBannerMobile() {

				if (this.internal_config.fixedMobile) {
					let firstEl = document.querySelector("#editor-content > .sitebuilder-element-panel");

					if (this.$el == firstEl)
						this.$root.$emit('setFixedStartPanel', this.internal_config.height)

					return this.$el == firstEl;
				}

				return false;
			},

			hideControl: function () {
				var classAdd = '';
				if (!this.internal_config.showMobile) {
					classAdd = classAdd + ' hide-on-mobile'
				}

				if (!this.internal_config.showDesktop) {
					classAdd = classAdd + ' hide-on-desktop'
				}

				return classAdd;
			},

			continueDelete() {
				$(this.$el).detach();
				this.$refs.delete.close();
			},

			duplicatePanel() {
				this.$root.$emit('duplicatePanel', this.id);
			},

			deletePanel() {
				this.$refs.delete.open();
			},

			reorderPanel(idx) {

				let id = this.id,
					sibling = idx === 1 ? document.getElementById(id).parentNode.nextSibling : document.getElementById(id).parentNode.previousSibling;

				if (sibling.firstChild === null) {
					return true;
				}

				this.$root.$emit('changeOrderPanel', id, sibling.firstChild.id, idx);

			},
			togglePanel() {
				this.$root.$emit('toggleElement', this);
			},
			showResources() {
				return this.$refs.resourcesData.getValuesData();
			},
			removeSelection() {
				let elements = document.getElementsByClassName('widget-focused');
				[].forEach.call(elements, function (el) {
					el.classList.remove("widget-focused");
				});
				this.$el.classList.add("widget-focused");

				this.$root.$emit('rSidebarEdition', this);
			},
			//change order on html
			changeOrderPanel(elem, idx) {
				let id = elem.$el.id,
					sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

				if (sibling === null) {
					return true;
				}

				let vm = this;
				let elements = this.$parent.changeOrderElements(vm.id, id, sibling.id, idx);

				vm.elements = {};
				this.$nextTick(function () {
					vm.elements = elements.childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
				})
			},
			getMinHeight: function () {
				let height = 0;
				let elements = this.$el.getElementsByClassName('sitebuilder-element-container');
				[].forEach.call(elements, function (el) {

					if ((el.offsetHeight + el.offsetTop) > height) {
						height = el.offsetHeight + el.offsetTop;
					}
				});

				return height + 10;
			},
			handler: function (e) {
				this.$refs.resourcesData.setMinValuesData('height', this.getMinHeight());
				this.$root.$emit('focusElement', this);
				this.$root.$emit('handlerElement', this);
				e.stopPropagation();
				e.preventDefault();
			},
		},
		mounted: function () {
			let device, childs, id, config;
			({device, childs, id, config} = this.$props);

			this.internal_config = config;
			this.device = device;
			this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
			if (typeof id !== 'undefined') {
				this.id = id;
			}

			this.internal_config = window.mergeRecursive(this.props, this.$props.config);

			if (typeof this.$props.config.anchorName !== 'undefined' && this.$props.config.anchorName !== '') {
				this.internal_config.id = this.$props.config.anchorName;
			}

			let vm = this;
			setTimeout(function () {

				if (vm.internal_config.parallaxActive == true) {
					$(vm.$refs.elem).jarallax({
						type: vm.internal_config.parallaxEffect,
						speed: vm.internal_config.parallaxSpeed / 10
					});
				}

			}, 1000);

			this.panelDividerEffect();

			this.$root.$emit('applyAnimation', this, 'sitebuilder-element-panel');

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .panel-video,
    .panel-video-place {
        position: absolute;
        min-width: 100%;
        min-height: 100%;
        overflow: hidden;
        left: 0;
    }

    .arrow-panel-down {
        position: absolute;
        z-index: 10;
    }

    .panel {
        width: 100%;
    }

    .sitebuilder-element-panel,
    .panel,
    .panel-body {
        position: relative;
    }

    .resizable {
        /* overflow: hidden; */
        resize: both
    }

    .draggable {
        /* position: relative; */
        /* z-index: 100 */
    }

    .draggable-handler {
        cursor: pointer
    }

    .dragging {
        cursor: move;
        /* z-index: 200 !important */
    }

    .panel-body {
        height: 100%;
    }

    .v--modal-overlay[data-modal="my_modal_name"] {
        background: transparent;
    }

    .container {
        /*border: 1px dotted gray;*/
    }

    .container-fluid {
        /*border: 1px dotted gray;*/
    }

</style>
